/* global __webpack_public_path__:writable */

import 'utils/googleTranslateFix';

try {
	__webpack_public_path__ = window.__BASE_URL__;
} catch (e) {}

import { h, render } from 'preact';
// import { getData } from 'utils/dynamicData';

import FocusFeaturesHubApp from 'base/focusFeaturesHub/focusFeaturesHubApp';

import { getDeviceInfo } from 'utils/bolt/client';

// loads + cache essential data ASAP
// (async () => {
// 	getData('navigation');
// })();

// Typically this is done in base/bolt.js, but as Hub has a different base this is not done
// Only adding browser info for now as other client info would need to be updated based on window events
function addBrowserInfo(store) {
	const { isIOS, isEdge, isSafari } = getDeviceInfo();
	Object.assign(store.client, { isIOS, isEdge, isSafari });
	return store;
}

let elem = document.getElementById('app');
if (!elem) {
	elem = document.createElement('div');
	elem.id = 'app';
	document.body.appendChild(elem);
}
const initialStore = addBrowserInfo(window.__INITIAL_STATE__ || {});
render(<FocusFeaturesHubApp initialStore={initialStore} />, elem, elem.firstChild);